export const getFiltersAssets = (state) => state.filtersSettings.assets;
export const getFiltersPresets = (state) => state.filtersSettings.presets;
export const getPresetError = (state) => state.filtersSettings.presetError;
